"use client";

import React from "react";
var __jsx = React.createElement;
import { CarsSearchProvider } from "@lib/context/cars/cars-search-context";
export default function CarsProviders(_ref) {
  let {
    children
  } = _ref;
  return __jsx(CarsSearchProvider, null, children);
}